<template>
  <head>
    <meta charset="utf-8" />
    <title>Transaction Lookup - County Biller</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Keep your finances and membership up to date" name="description" />
    <meta content="" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- Bootstrap CSS -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Icons CSS -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App CSS-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- Custom CSS-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- Add Font Awesome for better icons -->
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">

  </head>
  <body @contextmenu.prevent data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <NavigationBar/>
    <div class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <!-- Page header -->
          <div class="page-header">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h3 class="mb-1">Transaction Lookup</h3>
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item"><a href="dashboard.html">Dashboard</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Transaction Lookup</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>

          <!-- Main content card -->
          <div class="card">
            <div class="card-header">
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="card-title mb-0">Transaction History</h5>
                <div v-if="copiedTransaction" class="alert alert-success mb-0 py-2 px-3 fade-in">
                  <i class="fas fa-check-circle me-2"></i>
                  Transaction copied!
                </div>
              </div>
            </div>

            <!-- Search and filters -->
            <div class="card-body border-bottom pb-0">
              <div class="row g-3">
                <div class="col-md-5">
                  <div class="search-box position-relative">
                    <input
                        v-model="search"
                        type="text"
                        class="form-control search-input"
                        placeholder="Search by transaction code or description..."
                        @focus="searchFocused = true"
                        @blur="searchFocused = false"
                    >
                    <i class="bx bx-search-alt search-icon"></i>
                    <div v-if="search" class="clear-search" @click="search = ''">
                      <i class="bx bx-x"></i>
                    </div>
                  </div>
                </div>

                <div class="col-md-7">
                  <div class="d-flex gap-3 flex-wrap date-filter">
                    <div class="d-flex align-items-center flex-grow-1">
                      <label class="form-label mb-0 me-2">From:</label>
                      <input
                          v-model="dateFrom"
                          class="form-control"
                          type="date"
                          aria-label="Filter from date"
                      >
                    </div>

                    <div class="d-flex align-items-center flex-grow-1">
                      <label class="form-label mb-0 me-2">To:</label>
                      <input
                          v-model="dateTo"
                          class="form-control"
                          type="date"
                          aria-label="Filter to date"
                      >
                    </div>

                    <div class="dropdown">
                      <button class="btn btn-primary btn-sm dropdown-toggle ms-auto" type="button"
                              id="exportDropdown" data-bs-toggle="dropdown" aria-expanded="false"
                              :disabled="loading || ReconTransactions.length === 0">
                        <i class="bx bxs-download me-1"></i>
                        Export Report
                      </button>
                      <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="exportDropdown">
                        <li><a class="dropdown-item" href="#" @click.prevent="exportToPDF">Export to PDF</a></li>
                        <li><a class="dropdown-item" href="#" @click.prevent="exportToExcel">Export to Excel</a></li>
                        <li><a class="dropdown-item" href="#" @click.prevent="exportToCSV">Export to CSV</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Table content -->
            <div class="card-body">
              <!-- Data table -->
              <div class="table-responsive" v-if="ReconTransactions.length > 0 && !loading">
                <table class="table table-hover transaction-table" id="reconTable">
                  <thead>
                  <tr>
                    <th scope="col" style="width: 120px;">Date</th>
                    <th scope="col" style="width: 180px;">Transaction Code</th>
                    <th scope="col" style="width: 150px;">Amount</th>
                    <th scope="col">Description</th>
                    <th scope="col" style="width: 100px;">Actions</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, index) in ReconTransactions"
                      :key="index"
                      :class="{'highlight-row': highlightedRow === index}"
                      @click="selectRow(index)">
                    <td class="clickable-cell" @click="copyField(item.date, 'Date')">
                      <span class="copy-indicator">{{ item.date }}</span>
                    </td>
                    <td class="clickable-cell" @click="copyField(item.transactionCode, 'Transaction Code')">
                      <span class="copy-indicator transaction-code">{{ item.transactionCode }}</span>
                    </td>
                    <td class="clickable-cell" @click="copyField(formatPrice(item.amount), 'Amount')">
                      <span class="copy-indicator">KES {{ formatPrice(item.amount) }}</span>
                    </td>
                    <td class="clickable-cell" @click="copyField(item.description, 'Description')">
                      <span :class="[item.available === '1' ? 'unreconciled' : 'reconciled', 'copy-indicator']">
                        {{ item.description }}
                      </span>
                    </td>
                    <td>
                      <div class="d-flex gap-2 justify-content-center">
                        <button
                            class="btn btn-sm btn-outline-primary copy-btn"
                            @click.stop="copyTransaction(item)"
                            title="Copy entire transaction">
                          <i class="fas fa-copy"></i>
                        </button>
                        <button
                            class="btn btn-sm btn-outline-secondary"
                            @click.stop="viewDetails(item)"
                            title="View details">
                          <i class="fas fa-eye"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <!-- Loading state -->
              <div v-if="loading" class="loading-indicator">
                <div class="spinner-border text-primary mb-3" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <h5 class="mb-3">Loading Data</h5>
                <p class="text-muted text-center" style="max-width: 400px">
                  We're fetching your reconciliation data. This will only take a moment.
                </p>
              </div>

              <!-- Empty state -->
              <div v-if="ReconTransactions.length < 1 && !loading" class="empty-state">
                <img src="/assets/images/no-results.png" alt="No results found">
                <h5 class="mb-3">No Results Found</h5>
                <p class="text-muted" style="max-width: 400px; margin: 0 auto;">
                  We couldn't find any matching records. Try adjusting your search criteria or date filters.
                </p>
              </div>
            </div>

            <!-- Pagination -->
            <div class="card-footer bg-white">
              <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
                <div class="d-flex align-items-center">
                  <label class="mb-0 me-2 text-muted" style="font-size: 0.875rem">Rows per page:</label>
                  <select class="form-select form-select-sm" style="width: auto" v-model="pageSize">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                    <option value="1000">1000</option>
                    <option value="5000">5000</option>
                    <option value="100000000000000">All</option>
                  </select>
                </div>

                <div v-if="totalPages > 0" class="d-flex align-items-center">
                    <span class="me-3 text-muted" style="font-size: 0.875rem">
                      {{ summary.count }} total records
                    </span>

                  <ul class="pagination pagination-sm mb-0">
                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                      <a class="page-link" @click="prevPage" :disabled="currentPage === 1">
                        <i class="bx bx-chevron-left"></i>
                      </a>
                    </li>

                    <li v-for="page in pagination(currentPage, totalPages, 3)"
                        :key="page"
                        class="page-item"
                        :class="{ active: currentPage === page }">
                      <span v-if="page === '...'" class="page-link">{{ page }}</span>
                      <a v-else class="page-link" @click="goToPage(page)">{{ page }}</a>
                    </li>

                    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                      <a class="page-link" @click="nextPage" :disabled="currentPage === totalPages">
                        <i class="bx bx-chevron-right"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Quick copy tooltip -->
          <div v-if="showTooltip" class="copy-tooltip" :style="tooltipStyle">
            Click to copy {{ tooltipText }}
          </div>
        </div>
      </div>

      <!-- Transaction Details Modal -->
      <div class="modal fade" id="transactionDetails" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Transaction Details</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body" v-if="selectedTransaction">
              <div class="transaction-detail-item">
                <label>Date:</label>
                <div class="detail-value">
                  <span>{{ selectedTransaction.date }}</span>
                  <button class="btn btn-sm btn-outline-secondary ms-2" @click="copyField(selectedTransaction.date, 'Date')">
                    <i class="fas fa-copy"></i>
                  </button>
                </div>
              </div>
              <div class="transaction-detail-item">
                <label>Transaction Code:</label>
                <div class="detail-value">
                  <span class="transaction-code">{{ selectedTransaction.transactionCode }}</span>
                  <button class="btn btn-sm btn-outline-secondary ms-2" @click="copyField(selectedTransaction.transactionCode, 'Transaction Code')">
                    <i class="fas fa-copy"></i>
                  </button>
                </div>
              </div>
              <div class="transaction-detail-item">
                <label>Amount:</label>
                <div class="detail-value">
                  <span>KES {{ formatPrice(selectedTransaction.amount) }}</span>
                  <button class="btn btn-sm btn-outline-secondary ms-2" @click="copyField(formatPrice(selectedTransaction.amount), 'Amount')">
                    <i class="fas fa-copy"></i>
                  </button>
                </div>
              </div>
              <div class="transaction-detail-item">
                <label>Description:</label>
                <div class="detail-value">
                  <span>{{ selectedTransaction.description }}</span>
                  <button class="btn btn-sm btn-outline-secondary ms-2" @click="copyField(selectedTransaction.description, 'Description')">
                    <i class="fas fa-copy"></i>
                  </button>
                </div>
              </div>
              <div class="transaction-detail-item">
                <label>Status:</label>
                <div class="detail-value">
                  <span :class="selectedTransaction.available === '1' ? 'unreconciled' : 'reconciled'">
                    {{ selectedTransaction.available === '1' ? 'Unreconciled' : 'Reconciled' }}
                  </span>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary" @click="copyTransaction(selectedTransaction)">
                <i class="fas fa-copy me-2"></i>Copy All Details
              </button>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              <p class="mb-0 text-muted">&copy; 2025 County Biller</p>
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end">
                Powered by Best Birdy Billing System
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>

  </body>

</template>
<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import {paysol, execute, execute2, biller, executeDownload} from "@/api";

import * as XLSX from 'xlsx';


export default {
  name: "TransactionLookup",
  components: {NavigationBar},
  data() {
    return {
      search: '',
      searchFocused: false,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      summary: {
        count: 0,
        total: 0
      },
      totalAmount: null,
      dateTo: '',
      dateFrom: '',
      loading: false,
      ReconTransactions: [],
      copiedTransaction: false,
      highlightedRow: null,
      selectedTransaction: null,
      showTooltip: false,
      tooltipText: '',
      tooltipStyle: {
        top: '0px',
        left: '0px'
      }
    };
  },
  mounted() {
    this.getReconciledRecords();
    this.menuAccess();

    this.$watch('dateFrom', function() {
      if (this.dateFrom !== '' && this.dateTo !== '') {
        this.getReconciledRecords();
      }
    });

    this.$watch('dateTo', function() {
      if (this.dateFrom !== '' && this.dateTo !== '') {
        this.getReconciledRecords();
      }
    });

    // Add keyboard shortcuts
    document.addEventListener('keydown', this.handleKeyboardShortcuts);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
    document.removeEventListener('keydown', this.handleKeyboardShortcuts);
  },
  watch: {
    pageSize(newPageSize) {
      this.getReconciledRecords();
      const totalItems = this.summary.count;
      const newTotalPages = Math.ceil(totalItems / newPageSize);
      this.totalPages = newTotalPages;
      this.currentPage = 1;
    },
    search() {
      // Use debounce to avoid too many requests while typing
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.getReconciledRecords();
      }, 500);
    },
  },
  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Recon Details");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then(() => {
            // Access granted
          })
          .catch((e) => {
            console.error("Menu access error:", e);
          });
    },

    handleKeyboardShortcuts(event) {
      // Ctrl/Cmd + F to focus search
      if ((event.ctrlKey || event.metaKey) && event.key === 'f') {
        event.preventDefault();
        document.querySelector('.search-input').focus();
      }

      // Escape to clear search
      if (event.key === 'Escape' && this.search) {
        this.search = '';
      }
    },

    selectRow(index) {
      this.highlightedRow = index;
    },

    copyField(text, fieldName) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(() => {
          this.showCopyNotification(`${fieldName} copied!`);
        }).catch(() => {
          this.fallbackCopy(text);
        });
      } else {
        this.fallbackCopy(text);
      }
    },

    fallbackCopy(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        this.showCopyNotification('Copied!');
      } catch (err) {
        console.error('Failed to copy:', err);
      }
      document.body.removeChild(textArea);
    },

    copyTransaction(transaction) {
      const transactionText = `Date: ${transaction.date}
Transaction Code: ${transaction.transactionCode}
Amount: KES ${this.formatPrice(transaction.amount)}
Description: ${transaction.description}
Status: ${transaction.available === '1' ? 'Unreconciled' : 'Reconciled'}`;

      this.copyField(transactionText, 'Transaction details');
    },

    viewDetails(transaction) {
      this.selectedTransaction = transaction;
      const modal = new bootstrap.Modal(document.getElementById('transactionDetails'));
      modal.show();
    },

    showCopyNotification(message) {
      this.copiedTransaction = true;
      setTimeout(() => {
        this.copiedTransaction = false;
      }, 2000);
    },

    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = Math.min(start + maxVisibleButtons - 1, totalPages);
      }

      if (end > totalPages) {
        end = totalPages;
        start = Math.max(end - maxVisibleButtons + 1, 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
        pages.unshift(1);
      }

      if (end < totalPages) {
        pages.push("...");
        pages.push(totalPages);
      }

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getReconciledRecords();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getReconciledRecords();
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getReconciledRecords();
      }
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    // New methods for client-side export
    exportToPDF() {
      if (!this.dateFrom || !this.dateTo) {
        alert("Please select a date range first");
        return;
      }

      if (this.ReconTransactions.length === 0) {
        alert("No data available to export");
        return;
      }

      try {
        const { jsPDF } = window.jspdf;
        const doc = new jsPDF();

        // Add title and date range
        doc.setFontSize(16);
        doc.text("County Biller Reconciliation Report", 14, 15);
        doc.setFontSize(10);
        doc.text(`Date Range: ${this.dateFrom} to ${this.dateTo}`, 14, 22);
        doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 28);

        // Prepare table data
        const tableColumn = ["Date", "Transaction Code", "Amount", "Description", "Status"];
        const tableRows = [];

        this.ReconTransactions.forEach(item => {
          const status = item.available === '1' ? 'Unreconciled' : 'Reconciled';
          const amount = `KES ${this.formatPrice(item.amount)}`;
          const rowData = [
            item.date,
            item.transactionCode,
            amount,
            item.description,
            status
          ];
          tableRows.push(rowData);
        });

        // Generate table
        doc.autoTable({
          head: [tableColumn],
          body: tableRows,
          startY: 35,
          styles: { fontSize: 8, cellPadding: 2 },
          columnStyles: {
            0: { cellWidth: 25 },
            1: { cellWidth: 35 },
            2: { cellWidth: 30 },
            3: { cellWidth: 'auto' },
            4: { cellWidth: 25 }
          }
        });

        // Add summary info
        const finalY = doc.lastAutoTable.finalY + 10;
        doc.text(`Total Records: ${this.summary.count}`, 14, finalY);

        // Save PDF
        doc.save(`Reconciled_Records_${this.dateFrom}_to_${this.dateTo}.pdf`);
      } catch (error) {
        console.error("PDF export error:", error);
        alert("Failed to export to PDF. Please try again.");
      }
    },

    exportToExcel() {
      if (!this.dateFrom || !this.dateTo) {
        alert("Please select a date range first");
        return;
      }

      if (this.ReconTransactions.length === 0) {
        alert("No data available to export");
        return;
      }

      try {
        // Prepare worksheet data
        const workbook = XLSX.utils.book_new();

        // Format data for Excel
        const formattedData = this.ReconTransactions.map(item => {
          return {
            'Date': item.date,
            'Transaction Code': item.transactionCode,
            'Amount': `KES ${this.formatPrice(item.amount)}`,
            'Description': item.description,
            'Status': item.available === '1' ? 'Unreconciled' : 'Reconciled'
          };
        });

        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // Add title and date information in merged cells at the top
        XLSX.utils.sheet_add_aoa(worksheet, [
          ['County Biller Reconciliation Report'],
          [`Date Range: ${this.dateFrom} to ${this.dateTo}`],
          [`Generated on: ${new Date().toLocaleString()}`],
          [],  // Empty row before data
        ], { origin: 'A1' });

        // Set column widths
        const columnWidths = [
          { wch: 12 },  // Date
          { wch: 20 },  // Transaction Code
          { wch: 15 },  // Amount
          { wch: 50 },  // Description
          { wch: 12 },  // Status
        ];
        worksheet['!cols'] = columnWidths;

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Reconciliation');

        // Export as XLSX
        XLSX.writeFile(workbook, `Reconciled_Records_${this.dateFrom}_to_${this.dateTo}.xlsx`);
      } catch (error) {
        console.error("Excel export error:", error);
        alert("Failed to export to Excel. Please try again.");
      }
    },

    exportToCSV() {
      if (!this.dateFrom || !this.dateTo) {
        alert("Please select a date range first");
        return;
      }

      if (this.ReconTransactions.length === 0) {
        alert("No data available to export");
        return;
      }

      try {
        // Format data for CSV
        const formattedData = this.ReconTransactions.map(item => {
          return {
            'Date': item.date,
            'Transaction Code': item.transactionCode,
            'Amount': `KES ${this.formatPrice(item.amount)}`,
            'Description': item.description,
            'Status': item.available === '1' ? 'Unreconciled' : 'Reconciled'
          };
        });

        // Define fields for CSV
        const fields = ['Date', 'Transaction Code', 'Amount', 'Description', 'Status'];

        // Use papaparse or similar lib for CSV creation
        const csvContent = this.convertArrayToCSV(formattedData, fields);

        // Create blob and download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', `Reconciled_Records_${this.dateFrom}_to_${this.dateTo}.csv`);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("CSV export error:", error);
        alert("Failed to export to CSV. Please try again.");
      }
    },

    // Helper function to convert array to CSV
    convertArrayToCSV(data, fields) {
      // Create header row
      let csv = fields.join(',') + '\r\n';

      // Add data rows
      data.forEach(item => {
        const row = fields.map(field => {
          // Escape quotes and wrap in quotes if contains comma or quote
          const value = item[field] ? item[field].toString() : '';
          if (value.includes(',') || value.includes('"')) {
            return `"${value.replace(/"/g, '""')}"`;
          }
          return value;
        });
        csv += row.join(',') + '\r\n';
      });

      return csv;
    },

    getReconciledRecords() {
      this.loading = true;
      const data = new FormData();
      data.append("function", "getReconciledRecords");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("search", this.search);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);

      execute(data, biller)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.ReconTransactions = res.data.data.ReconTransactions;
              this.summary = res.data.data.summary;
              this.totalPages = Math.ceil(this.summary.count / this.pageSize);
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error("Error fetching records:", e);
          });
    }
  },
};
</script>

<style scoped>
/* Custom styles for improved UI */
.page-header {
  background-color: #f8f9fa;
  border-radius: 0.5rem;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.card {
  border: none;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
}

.card-header {
  background-color: #fff;
  border-bottom: 1px solid #f1f1f1;
  padding: 1rem 1.5rem;
}

.search-box {
  position: relative;
}

.search-box .form-control {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  border-radius: 50rem;
  transition: all 0.3s ease;
}

.search-box .form-control:focus {
  box-shadow: 0 0 0 0.25rem rgba(79, 70, 229, 0.1);
}

.search-box .search-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
}

.clear-search {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #6b7280;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.clear-search:hover {
  background-color: #f3f4f6;
  color: #4b5563;
}

.date-filter {
  border-radius: 0.4rem;
  border: 1px solid #e2e8f0;
  padding: 0.5rem;
  background-color: #f8fafc;
}

/* Enhanced table styles */
.transaction-table {
  border-collapse: separate;
  border-spacing: 0;
}

.transaction-table th {
  font-weight: 600;
  font-size: 0.875rem;
  background-color: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  padding: 0.75rem 1rem;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  color: #6b7280;
  position: sticky;
  top: 0;
  z-index: 10;
}

.transaction-table td {
  padding: 1rem;
  border-bottom: 1px solid #f3f4f6;
  vertical-align: middle;
}

.transaction-table tbody tr {
  transition: all 0.2s ease;
}

.transaction-table tbody tr:hover {
  background-color: #f9fafb;
  cursor: pointer;
}

.transaction-table tbody tr.highlight-row {
  background-color: #ede9fe;
}

/* Clickable cells */
.clickable-cell {
  position: relative;
  cursor: pointer;
  user-select: text;
}

.clickable-cell:hover .copy-indicator {
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 3px;
}

.transaction-code {
  font-family: 'Courier New', monospace;
  font-weight: 600;
  color: #4338ca;
}

/* Copy button styles */
.copy-btn {
  transition: all 0.2s ease;
}

.copy-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Status styles */
.reconciled {
  color: #10b981 !important;
  font-weight: 500;
}

.unreconciled {
  color: #2563eb !important;
  font-weight: 500;
}

/* Copy notification */
.fade-in {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Tooltip styles */
.copy-tooltip {
  position: fixed;
  background-color: #1f2937;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  pointer-events: none;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* Transaction details modal */
.transaction-detail-item {
  padding: 0.75rem 0;
  border-bottom: 1px solid #f3f4f6;
}

.transaction-detail-item:last-child {
  border-bottom: none;
}

.transaction-detail-item label {
  font-weight: 600;
  color: #4b5563;
  margin-bottom: 0.25rem;
  display: block;
}

.detail-value {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.detail-value span {
  flex: 1;
}

/* Pagination styles */
.pagination {
  margin-bottom: 0;
}

.page-link {
  border-radius: 0.25rem;
  margin: 0 0.2rem;
  cursor: pointer;
}

.page-item.active .page-link {
  background-color: #4f46e5;
  border-color: #4f46e5;
}

.empty-state {
  padding: 4rem 2rem;
  text-align: center;
}

.empty-state img {
  max-width: 200px;
  margin-bottom: 1.5rem;
  opacity: 0.7;
}

.loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
}

.btn-primary {
  background-color: #4f46e5;
  border-color: #4f46e5;
}

.btn-primary:hover {
  background-color: #4338ca;
  border-color: #4338ca;
}

/* Responsive improvements */
@media (max-width: 768px) {
  .date-filter {
    flex-direction: column;
    gap: 0.5rem;
  }

  .date-filter input {
    width: 100%;
  }

  .transaction-table {
    font-size: 0.875rem;
  }

  .transaction-table th,
  .transaction-table td {
    padding: 0.5rem;
  }

  .copy-btn {
    padding: 0.25rem 0.5rem;
  }
}

/* Export dropdown styling */
.dropdown-menu {
  border: none;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border-radius: 0.5rem;
  padding: 0.5rem 0;
}

.dropdown-item {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  color: #4b5563;
  transition: all 0.2s ease;
}

.dropdown-item:hover {
  background-color: #f3f4f6;
  color: #4f46e5;
}

.dropdown-item:active {
  background-color: #ede9fe;
  color: #4f46e5;
}

/* Button improvements */
button:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.btn-sm {
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
}

.btn-outline-primary {
  color: #4f46e5;
  border-color: #4f46e5;
}

.btn-outline-primary:hover {
  background-color: #4f46e5;
  border-color: #4f46e5;
  color: white;
}

.btn-outline-secondary {
  color: #6b7280;
  border-color: #e5e7eb;
}

.btn-outline-secondary:hover {
  background-color: #f3f4f6;
  border-color: #d1d5db;
  color: #4b5563;
}

/* Modal styling enhancements */
.modal-content {
  border: none;
  border-radius: 0.75rem;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
}

.modal-header {
  border-bottom: 1px solid #f3f4f6;
  padding: 1.25rem 1.5rem;
}

.modal-title {
  font-weight: 600;
  color: #111827;
}

.modal-body {
  padding: 1.5rem;
}

.modal-footer {
  border-top: 1px solid #f3f4f6;
  padding: 1.25rem 1.5rem;
}

/* Form controls styling */
.form-label {
  font-weight: 500;
  color: #4b5563;
  margin-bottom: 0.5rem;
}

.form-control, .form-select {
  border-color: #e5e7eb;
  border-radius: 0.375rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
}

.form-control:focus, .form-select:focus {
  border-color: #a5b4fc;
  box-shadow: 0 0 0 0.25rem rgba(79, 70, 229, 0.1);
}

.input-group-text {
  background-color: #f9fafb;
  border-color: #e5e7eb;
  color: #6b7280;
}

/* Search highlight */
.search-input.focused {
  border-color: #a5b4fc;
  box-shadow: 0 0 0 0.25rem rgba(79, 70, 229, 0.1);
}
</style>